import React, { useState, createElement } from 'react';
import { ClipboardCopyIcon, CheckIcon } from 'lucide-react';
export function CopyButton({
  textToCopy,
  htmlContent
}) {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    if (!textToCopy) return;
    try {
      // If HTML content is provided, use it for rich text copying
      if (htmlContent) {
        // Create a clipboard item with both plain text and HTML formats
        const clipboardItem = new ClipboardItem({
          'text/plain': new Blob([textToCopy], {
            type: 'text/plain'
          }),
          'text/html': new Blob([htmlContent], {
            type: 'text/html'
          })
        });
        await navigator.clipboard.write([clipboardItem]);
      } else {
        // Fall back to plain text copying
        await navigator.clipboard.writeText(textToCopy);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Fallback for browsers that don't support the Clipboard API
      try {
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (fallbackErr) {
        console.error('Fallback copy method failed: ', fallbackErr);
      }
    }
  };
  return <button onClick={handleCopy} disabled={!textToCopy} className={`flex items-center gap-1 px-2 sm:px-3 py-1.5 rounded-md text-xs sm:text-sm font-medium transition-colors ${textToCopy ? 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`} data-id="element-4">
      {copied ? <>
          <CheckIcon size={14} className="sm:w-4 sm:h-4" data-id="element-5" />
          <span data-id="element-6">Copied!</span>
        </> : <>
          <ClipboardCopyIcon size={14} className="sm:w-4 sm:h-4" data-id="element-7" />
          <span data-id="element-8">Copy</span>
        </>}
    </button>;
}